import React from 'react';
import { useRecoilValue } from 'recoil';
import { blockDateRange, blockDisplayHeader, customizedBlock } from 'venn-state';
import { Block } from '../../components/core';
import { DefaultSubjects } from '../../components/secondary/subjects/default-subjects';
import { EndDateRange } from '../../components/secondary/date-ranges';

export const TaxImpactHeader = ({ id }: { id: string }) => {
  const title = useRecoilValue(blockDisplayHeader(id));
  const { selectedMetrics, relativeToBenchmark, subHeader } = useRecoilValue(customizedBlock(id));
  const dateRange = useRecoilValue(blockDateRange(id));

  return (
    <>
      <Block.HeaderTopContainer id={id}>
        <Block.Title>
          <Block.Headline id={id}>{title}</Block.Headline>
          {subHeader && <Block.SubHeadline id={id}>{subHeader}</Block.SubHeadline>}
        </Block.Title>

        <Block.Metadata id={id}>
          <EndDateRange dateRange={dateRange} />
        </Block.Metadata>
      </Block.HeaderTopContainer>

      <DefaultSubjects id={id} metric={selectedMetrics[0]! || ''} relativeToBenchmark={relativeToBenchmark} />
    </>
  );
};
